import { communicationService, DiProcess, UapLoadStatus, utils } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { AD_ENGINE_UAP_LOAD_STATUS } from '../../../communication/events/events-ad-engine-uap';
import { addExperimentGroupToTargeting } from '../utils/experiment-targeting';

@Injectable()
export class DirectTrafficPredictionValidatorSetup implements DiProcess {
	async execute() {
		communicationService.on(AD_ENGINE_UAP_LOAD_STATUS, (action: UapLoadStatus) => {
			const isLoadedUap = action.isLoaded;
			const directTrafficPredictionResult = window?.isDirectAd;

			if (directTrafficPredictionResult !== undefined) {
				const keyVal = `prediction_${directTrafficPredictionResult ? 1 : 0}_uap_${
					isLoadedUap ? 1 : 0
				}`;

				addExperimentGroupToTargeting(keyVal);

				utils.logger(
					'direct-traffic-prediction',
					`UAP: ${isLoadedUap}, Prediction: ${directTrafficPredictionResult}`,
				);
			}
		});
	}
}
